import React, { useContext } from "react";
import { FaCheckDouble, FaHandshake, FaFileSignature, FaSearchPlus } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import '../Audit/AuditGlobal.css';
import BannerImage from '../../assets/core_services/tpi_certification_hero_1776820103072.png';

function TPICertification() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/tpi-certification');
    } else {
      navigate('/login', { state: { from: '/booking/tpi-certification' } });
    }
  };

  return (
    <div className="audit-page">
      <div className="audit-max-width">

        {/* --- HERO --- */}
        <div className="audit-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Core Services</span>
          <h1 className="hero-title">TPI Certification</h1>
          <p className="hero-subtitle">
            Independent Third-Party Inspection services to verify quality, compliance, and specifications across your supply chain.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Enquire Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Unbiased Quality Assurance</h2>
              <p className="article-text">
                Third-Party Inspection (TPI) provides an independent evaluation of products, materials, and processes. Our TPI services ensure that your suppliers and contractors adhere to the required specifications, codes, and international standards, delivering confidence in your procurement and projects.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Inspection Scope</h2>
              <p className="article-text">
                We offer a wide range of TPI services, including:
                <br />- <strong>Vendor Inspection:</strong> Assessments at the manufacturer's facility.
                <br />- <strong>Pre-Shipment Inspection (PSI):</strong> Verification of goods before dispatch.
                <br />- <strong>Site Inspection:</strong> Monitoring construction and installation processes.
                <br />- <strong>Witnessing & Verification:</strong> Overseeing critical testing and commissioning activities.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Adding Value Through Trust</h2>
              <p className="article-text">
                By utilizing our TPI services, you mitigate risks associated with defective products, project delays, and non-compliance, ultimately protecting your brand reputation and bottom line.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Why Use TPI?</h4>
              <ul className="key-list">
                <li><FaHandshake className="check-icon" /> Independent Verification</li>
                <li><FaSearchPlus className="check-icon" /> Defect Prevention</li>
                <li><FaFileSignature className="check-icon" /> Code Compliance</li>
                <li><FaCheckDouble className="check-icon" /> Quality Assurance</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Need TPI Support?</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Ensure your project standards are met by independent experts.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Request TPI
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default TPICertification;
